import React from 'react';
import { PaarPassportContainer } from '../../container';

const PaarPassportPage = () => {
  return (
    <>
      <PaarPassportContainer />
    </>
  );
};

export default PaarPassportPage;
